// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__13F-u","buttons":"SendReceipts_buttons__3NTmi","email":"SendReceipts_email__2Ab4Q","bookApptTitle":"SendReceipts_bookApptTitle__USv4p"};